// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"ff1ab8e3","143":"1eea981d","199":"ff1ab8e3","580":"038db700","667":"ff1ab8e3","857":"ff1ab8e3"}[chunkId] + ".chunk.css";
};